import * as React from 'react';
import { IGDStats, initialGDStats } from '../types/types';
import { StatisticsService, StatsTypes } from 'src/share/services/statistics';
import { getCurrentTime, getUnixTimeStamp } from 'src/share/utils/utils';

export const useGlobalStats = (): { stats: IGDStats; lastUpdate: string } => {
  const [stats, setStats] = React.useState<IGDStats>(initialGDStats);
  const [lastUpdate, setLastUpdate] = React.useState('');
  React.useEffect(() => {
    async function fetchStats(): Promise<void> {
      const statistics = await StatisticsService.getStats(
        StatsTypes.GLOBALDASHBOARD,
        {
          date: getUnixTimeStamp(),
        }
      );
      setStats({
        alertsIssued: statistics.alerts_issued,
        alertsByCountry: statistics.alerts_by_country,
        latestCases: statistics.latest_cases,
        latestAlerts: statistics.latest_alerts,
        casesWithAlerts: statistics.cases_with_alerts,
        casesByCountry: statistics.cases_by_country,
        casesByWeek: statistics.cases_by_week,
        engagedPeople: statistics.engaged_people,
        impressions: statistics.impressions,
        closedPercentage: statistics.closed_percentage.toFixed(1),
        closedNumber: statistics.closed_number,
        recentCases: statistics.recent_cases,
        lastHoursUpdate: statistics.last_n_hours_update,
      });
      setLastUpdate(getCurrentTime());
    }
    fetchStats();
    const interval = setInterval(() => {
      fetchStats();
    }, 300000);
    return (): void => clearInterval(interval);
  }, []);
  return { stats, lastUpdate };
};
